import { Component, OnInit, inject } from '@angular/core';

// Services
import { WidgetsService } from '@services/widgets.service';

// Models
import { LOCAL_STORAGE_KEYS } from '@constants/storage.constants';

@Component({
  selector: 'app-preloader',
  imports: [],
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.scss'],
})
export class PreloaderComponent implements OnInit {
  public widgetsService = inject(WidgetsService);

  public widgetStatus: boolean;
  public frameStatus: boolean;

  ngOnInit(): void {
    this.setStatusApp();
  }

  setStatusApp(): void {
    const linkType = localStorage.getItem(LOCAL_STORAGE_KEYS.LINK_TYPE);
    this.frameStatus = linkType ? linkType === 'FRAME' : false;
    this.widgetStatus = this.widgetsService.getWidgetStatus();
  }
}
